import getStore from '../store/store';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

export default function getIsTimePanelView() {
    const { calendarComponent } = getStore();
    return calendarComponent == CalendarComponent.MyDayPanelCompose;
}
